"use client";

import { ErrorPageContent } from "@/components/shared/ErrorPage";
import { Card, CardContent } from "@/components/ui/card";
import { ROUTES } from "@/constants/routes";
import { useCorrelationId } from "@/contexts/CorrelationContext";
import { useErrorPage } from "@/hooks/error/useErrorPage";
import { useRouter } from "next/navigation";

interface ErrorPageProps {
  error: Error & { digest?: string; correlationId?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorPageProps): React.JSX.Element {
  const router = useRouter();
  const { getLastCorrelationId } = useCorrelationId();

  const { identifier, displayError } = useErrorPage({
    error,
    getCorrelationId: getLastCorrelationId,
  });

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <ErrorPageContent
            error={displayError}
            supportId={identifier}
            onReload={reset}
            onGoHome={() => router.push(ROUTES.HOME)}
            showErrorDetails={true}
          />
        </CardContent>
      </Card>
    </div>
  );
}
